export default {"src":"/_next/static/media/icon-face-search.ded171f3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};